import React from "react";
import {
  Alert,
  Box,
  Button,
  FormControlLabel,
  FormGroup,
  Grid,
  Icon,
  Paper,
  Snackbar,
  Switch,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import axios from "../../../../api/axios";
import {
  CEPInput,
  DocumentInput,
  EmailInput,
  GroupHeader,
  GroupItems,
  MoneyInput,
  PhoneInput,
  SelectComponent,
  SelectWithSearchComponent,
  SwitchComponent,
  TextFieldComponent,
} from "../../../../components/misc/form";
import MediaUpload from "../../../../components/mediaUpload";
import useAlert from "../../../../globalComponents/useAlerts";
import { unmaskMoney } from "../../../../functions";
import useRewards from "./useRewards";

const CreateCustomer = () => {
  const { showLoading, showAlert, dismissLoading } = useAlert();

  const navigate = useNavigate();
  const {
    register,
    handleSubmit: formSubmit,
    control,
    setValue,
    setFocus,
    watch,
  } = useForm();
  const [loading, setLoading] = useState(false);

  const { expireAt, customExpire, product } = watch();

  const refs = {};

  const handleSubmit = async (form) => {
    try {
      showLoading();

      if (!form.product) throw new Error("Selecione um produto!");

      form.value = unmaskMoney(form.value);
      if (!form.value) throw new Error("Valor do produto inválido!");
      if (form.requiredPoints < 0)
        throw new Error("Pontos para resgate não podem ser menor que ZERO!");
      if (form.quantity < 0)
        throw new Error("Quantidade não ser menor que ZERO!");

      const data = await axios.post("/rewards", form);

      if (!data)
        throw new Error(
          "Não foi possível registrar prêmio. Verifique os parâmetros e tente novamente!",
        );

      showAlert({
        title: "Concluído",
        description: `Grupo de premiação "${data.groupCode}" registrado com sucesso!`,
        onClose: () => navigate("./../"),
      });
    } catch (err) {
      showAlert({ title: "Atenção", description: err.message });
    }
  };

  const { availableProducts } = useRewards();

  return (
    <Box
      sx={{
        height: "100vh", // full screen
        //=display: "flex",
        justifyContent: "center",
        alignItems: "center",
        paddingBottom: 30,
      }}
    >
      <Typography variant="h4" gutterBottom>
        Cadastro de Prêmio
      </Typography>

      <Paper
        elevation={3}
        sx={{
          //width: 400,
          maxHeight: "80vh", // limit height
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          onSubmit={formSubmit(handleSubmit)}
          component="form"
          sx={{
            p: 2,
            overflowY: "auto", // 🔥 enables scroll
            flex: 1, // fills available space
          }}
        >
          <Grid container spacing={2} mt={1}>
            <Typography variant="h6" mt={1}>
              Dados do Produto
            </Typography>
            <Grid container size={{ xs: 12 }}>
              <Grid size={{ xs: 12, md: 4, lg: 4 }}>
                <Paper
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "5px",
                  }}
                >
                  <MediaUpload
                    preview={product?.imageUrl}
                    forwardRef={(ref) => (refs.imageUrl = ref)}
                    acceptTypes=".jpeg,.jpg,.png,.webp,"
                    style={{ maxHeight: 100 }}
                  >
                    {({ onUploadRequest, media }) => (
                      <Button disabled>
                        <div>
                          {media.thumbnail || (
                            <Icon
                              style={{
                                fontSize: 150,
                                alignSelf: "center",
                                color: "#ccc",
                              }}
                            >
                              photo
                            </Icon>
                          )}
                        </div>
                      </Button>
                    )}
                  </MediaUpload>
                </Paper>
              </Grid>
              <Grid container size={{ xs: 12, md: 8, lg: 8 }}>
                <Grid size={{ xs: 12, sm: 12, md: 12 }}>
                  <SelectWithSearchComponent
                    name="product"
                    control={control}
                    label={"Produto"}
                    fullWidth
                    required
                    groupBy={(option) => option.group}
                    values={availableProducts.sort((a, b) => b.title - a.title)}
                    renderGroup={(params) => (
                      <li key={params.key}>
                        <GroupHeader
                          sx={{
                            color: "#fff",
                            // background:
                            //   params.group === PRODUCT_STATUS.TOTAL_AVAILABLE
                            //     ? "green"
                            //     : params.group ===
                            //         PRODUCT_STATUS.PARTIAL_AVAILABLE
                            //       ? "blue"
                            //       : "rgba(0,0,0,0.6)",
                          }}
                        >
                          <b>{params.group}</b>
                        </GroupHeader>
                        <GroupItems>{params.children}</GroupItems>
                      </li>
                    )}
                  />
                </Grid>

                <Grid size={{ xs: 12, md: 6, lg: 6 }}>
                  <MoneyInput
                    name="value"
                    control={control}
                    label={"Valor"}
                    fullWidth
                    required
                  />
                </Grid>
                <Grid size={{ xs: 12, md: 6, lg: 6 }}>
                  <TextFieldComponent
                    name="quantity"
                    control={control}
                    label={"Quantidade"}
                    fullWidth
                    type="number"
                    required
                  />
                </Grid>
                <Grid size={{ xs: 12 }}>
                  <TextFieldComponent
                    name="requiredPoints"
                    control={control}
                    label={"Pontos para resgate"}
                    fullWidth
                    type="number"
                    required
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item>
            <Button
              loading={loading}
              variant="contained"
              color="primary"
              type="submit"
              sx={{ mt: 3 }}
            >
              Salvar
            </Button>
          </Grid>
        </Box>
      </Paper>
    </Box>
  );
};

export default CreateCustomer;
